import React from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space, Select, DatePicker } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import axios, { axiosTable, baseAxiosNoInfo } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'

const { Column } = Table
const { Option } = Select

interface State {
    data: object[],
    brand: object[],
    citys: object[],
    loading: boolean,
    pagination: {
        current: number,
        pageSize: number,
        total: number
    },
    fetchOtherParams: {
        store_name: string | null,
        item_type: string | null,
        item_name: string | null,
        city_code: string | null,
        item_status: string | null,
        tenant_brand_list_id: string | null,
        store_status: string | null
    },
    formParams: {
        item_type: string | null
    },
    offShelfVisible: boolean,
    addVisible: false
}

export default class StoreList extends React.Component {
    state: State = {
        data: [],
        brand: [],
        citys: [],
        loading: false,
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0
        },
        fetchOtherParams: {
            item_type: null,
            item_name: null,
            city_code: null,
            store_name: null,
            item_status: null,
            tenant_brand_list_id: null,
            store_status: null
        },
        formParams: {
            item_type: null
        },
        offShelfVisible: false,
        addVisible: false
    }

    componentDidMount() {
        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
        this.getBrandList()
        this.getCityList()
    }

    offShelf() {
        this.setState({ offShelfVisible: true })
    }

    handleSelectChange(value: string) {
        let { fetchOtherParams } = this.state;
        fetchOtherParams.tenant_brand_list_id = value

        this.setState({
            fetchOtherParams
        })
    }

    handleSelectChange1(value: string) {
        let { fetchOtherParams } = this.state;
        fetchOtherParams.city_code = value

        this.setState({
            fetchOtherParams
        })
    }

    handleInputChange(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.store_name = e.target.value

        this.setState({ fetchOtherParams })
    }

    handleStatusChange(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.store_status = e

        this.setState({ fetchOtherParams })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current
        pagination.pageSize = antPagination.pageSize

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/manage_center/store/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            const { pagination } = this.state
            pagination.total = response.total
            pagination.pageSize = response.size
            pagination.current = response.current

            this.setState({
                pagination,
                data: response.records
            })
        })
    }

    resetForm() {
        let { fetchOtherParams } = this.state
        fetchOtherParams.tenant_brand_list_id = null
        fetchOtherParams.store_name = null
        fetchOtherParams.store_status = null
        fetchOtherParams.city_code = null
        fetchOtherParams.item_status = null

        this.setState({ fetchOtherParams })
        this.selectState('')
    }

    getBrandList() {
        axiosTable.get('/manage_center/brand/list', {

        }).then((response: any) => {
            if (!response) {
                response = []
            }

            this.setState({
                brand: response
            })
        })
    }

    getCityList() {
        baseAxiosNoInfo.get('/manage_center/store/store_city_list', {

        }).then((response: any) => {
            if (response.length == 0) {
                response = []
            }

            this.setState({
                citys: response
            })
        })
    }

    selectState(type: string) {
        let { pagination, fetchOtherParams } = this.state;

        if (type != 'current') {
            pagination.current = 1;
        }

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    changeStatus(item: any, status: number) {
        axios.post('/manage_center/store/update_status', {
            id: item.id,
            store_status: status

        }).then(res => {
            this.selectState('current')
        })
    }

    render() {
        let { store_name, item_name } = this.state.fetchOtherParams

        return (<div className="common-page">
            {/* 管理中心 -> 品牌及门店 -> 门店管理 */}
            <BreadCrumb position={['管理中心', '门店管理']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="门店名称" value={store_name === null ? '' : store_name} onChange={this.handleInputChange.bind(this)} />
                    <Select style={{ marginRight: 8, marginBottom: 12, width: '150px' }} allowClear={true} value={this.state.fetchOtherParams.tenant_brand_list_id as string} onChange={this.handleSelectChange.bind(this)} placeholder="所属品牌">
                        {this.state.brand.map((item: any) => {
                            return <Option value={item.id} key={item.id}>{item.brand_name}</Option>
                        })}
                    </Select>
                    <Select style={{ marginRight: 8, marginBottom: 12, width: '150px' }} allowClear={true} value={this.state.fetchOtherParams.city_code as string} onChange={this.handleSelectChange1.bind(this)} placeholder="所在城市">
                        {this.state.citys.map((item: any) => {
                            return <Option value={item.city_code} key={item.city_code}>{item.city_name}</Option>
                        })}
                    </Select>
                    <Select style={{ marginRight: 8, marginBottom: 12, width: 120 }} allowClear={true} value={this.state.fetchOtherParams.store_status as string} onChange={this.handleStatusChange.bind(this)} placeholder="门店状态">
                        <Option value="1">启用</Option>
                        <Option value="2">禁用</Option>
                    </Select>
                </Space>

                <div style={{ marginTop: 10 }}>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={this.selectState.bind(this, '')} >查询</Button>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={this.resetForm.bind(this)} icon={<RedoOutlined />}>重置</Button>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary"><Link to={"/store_add"}>添加</Link></Button>
                </div>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} pagination={this.state.pagination} rowKey="id" onChange={this.handleTableChange.bind(this)}>
                    <Column title="门店名称" dataIndex="store_name" key="store_name" />
                    <Column title="所属品牌" dataIndex="brand_name" key="brand_name" />
                    <Column title="所在城市" dataIndex="city_name" key="city_name" />
                    <Column title="门店状态" dataIndex="store_status" key="store_status" render={(value: number): string => value === 1 ? '启用' : '禁用'} />
                    <Column title="创建时间" dataIndex="create_date" key="create_date" />

                    <Column
                        title="操作"
                        key="action"
                        render={(text, record: any) => (
                            <Space size="middle">
                                <Link to={"/store_edit/" + record.id}><Button type="primary">编辑</Button></Link>
                                {
                                    record.store_status == 1 ?
                                        <Button type="primary" onClick={this.changeStatus.bind(this, record, 2)}>禁用</Button> :
                                        <Button type="primary" onClick={this.changeStatus.bind(this, record, 1)}>启用</Button>
                                }
                            </Space>
                        )}
                    />
                </Table>
            </div>
        </div>)
    }
}